import React from 'react';
import { isBedroomOptionDisabled } from '../../../utils/formOptions';
import { buildBedroomOptions } from '../../../utils/bedroomOptionsUtils';

function MobileBedroomsField({
  maxBedroomsData,
  minBedrooms,
  maxBedrooms,
  onMinBedroomsChange,
  onMaxBedroomsChange,
}) {
  const bedroomOptions = buildBedroomOptions(Number(maxBedroomsData));
  return (
    <div>
      <fieldset className="px-4">
        <legend className="block font-medium text-black text-sm mb-3">
          Bedrooms
        </legend>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label
              className="block font-light text-xs mb-2"
              htmlFor="mobile-min-bedrooms"
            >
              Minimum bedrooms
            </label>
            <div className="relative">
              <select
                id="mobile-min-bedrooms"
                className="px-3 min-h-[42px] text-[#6B7280] bg-grey-100 w-full border border-[#ebebeb] appearance-none rounded"
                value={minBedrooms}
                onChange={(e) => onMinBedroomsChange(e.target.value)}
              >
                <option value="">No min</option>
                {bedroomOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={isBedroomOptionDisabled(
                      option.value,
                      'min',
                      minBedrooms,
                      maxBedrooms
                    )}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              <svg
                width="10"
                height="7"
                aria-hidden="true"
                focusable="false"
                className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-[#6B7280]"
              >
                <use href="#icon-chevron-down" />
              </svg>
            </div>
          </div>
          <div>
            <label
              className="block font-light text-xs mb-2"
              htmlFor="mobile-max-bedrooms"
            >
              Maximum bedrooms
            </label>
            <div className="relative">
              <select
                id="mobile-max-bedrooms"
                className="px-3 min-h-[42px] text-[#6B7280] bg-grey-100 w-full border border-[#ebebeb] appearance-none rounded"
                value={maxBedrooms}
                onChange={(e) => onMaxBedroomsChange(e.target.value)}
              >
                <option value="">No max</option>
                {bedroomOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={isBedroomOptionDisabled(
                      option.value,
                      'max',
                      minBedrooms,
                      maxBedrooms
                    )}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              <svg
                width="10"
                height="7"
                aria-hidden="true"
                focusable="false"
                className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-[#6B7280]"
              >
                <use href="#icon-chevron-down" />
              </svg>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  );
}

export default MobileBedroomsField;
